<template>
  <div class="add-article">
    <el-form ref="form" :model="data" :rules="rules" label-width="80px">
      <el-form-item label="用户帐号" prop="username">
        <el-input :disabled="data.objectId" v-model="data.username"></el-input>
      </el-form-item>
      <el-form-item label="用户密码" prop="password" v-if="!data.objectId">
        <el-input type="password" v-model="data.password"></el-input>
      </el-form-item>
      <el-form-item label="用户昵称" prop="nickname">
        <el-input v-model="data.nickname"></el-input>
      </el-form-item>
      <el-form-item label="用户手机" prop="mobilePhoneNumber">
        <el-input v-model="data.mobilePhoneNumber"></el-input>
      </el-form-item>
      <el-form-item label="用户类型" prop="userType">
        <el-select v-model="data.userType" placeholder="请选择" style="width:100%">
          <el-option v-for="(item,key) in userType" :key="key" :label="item" :value="parseInt(key)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button @click="backList">返回列表</el-button>
        <el-button type="primary" :disabled="grade.userUpdate||loading" @click="saveUser">保存用户</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script type="text/javascript">
import utils from "@/utils/index";
import common from "@/../server/common";
import "@/components/index";

export default {
  name: "list",
  data() {
    const _this = this;
    return {
      page_grade: common.page_grade,
      grade: {
        userUpdate: !0
      },
      userType: common.user_type,
      loading: false,
      data: {
        username: "",
        password: "",
        mobilePhoneNumber: "",
        userType: 1,
        nickname: ""
      },
      rules: {
        username: [
          {
            required: true,
            message: "用户帐号不能为空！",
            trigger: "change"
          }
        ],
        password: [
          {
            required: true,
            message: "密码不能为空！",
            trigger: "change"
          }
        ],
        nickname: [
          {
            required: true,
            message: "昵称不能为空！",
            trigger: "change"
          }
        ],
        userType: [
          {
            required: true,
            message: "请选择用户类型",
            trigger: "change"
          }
        ],
        mobilePhoneNumber: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              }
              if (!common.mobile_reg.test(value)) {
                callback(new Error(common.mobile_txt));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    saveUser() {
      this.$refs.form.validate(v => {
        if (v) {
          utils.ajax.call(this, "/updateUser", this.data, (data, err) => {
            this.loading = false;
            if (!err) {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.$router.push("/user/list");
            }
          });
        }
      });
    },
    backList() {
      this.$router.push("/user/list");
    }
  },
  mounted() {
    let id = this.$route.query.id;
    if (id) {
      utils.ajax.call(this, "/getUserById", { id }, (obj, err) => {
        if (!err) {
          this.data = obj;
        }
      });
    }
  },
  mixins: [common.mixin]
};
</script>
